// @flow
import { createStore, applyMiddleware, combineReducers } from "redux";
import thunk from "redux-thunk";
import { connectRouter, routerMiddleware } from "connected-react-router";
import { composeWithDevTools } from "redux-devtools-extension/developmentOnly";
import { createLogger } from "redux-logger";
import { isDev } from "utils/envUtils";
import { history } from "root/routes";
import { getLogger } from "common/logger";
import reducers from "root/reducers";

const logger = getLogger();

logger.log("[store]: Creating UW store");

const middleware: any[] = [
	thunk,
	routerMiddleware(history),
];

if (isDev()) {
	middleware.push(createLogger()); // logger must be the last mw
}

const createRootReducer = (history) => combineReducers({
	router: connectRouter(history),
	...reducers,
});

const store: Object = createStore(
	createRootReducer(history),
	composeWithDevTools(
		applyMiddleware(...middleware),
	),
);

export default () => store;
